var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.15 6.70009L15.5363 6.31389C16.1761 5.67402 17.2136 5.67402 17.8534 6.31389C18.4933 6.95377 18.4933 7.99122 17.8534 8.63107L17.4673 9.01732M15.15 6.70009C15.15 6.70009 15.1983 7.52077 15.9224 8.24489C16.6466 8.96898 17.4673 9.01732 17.4673 9.01732M15.15 6.70009L11.5995 10.2506C11.359 10.4911 11.2388 10.6113 11.1353 10.7439C11.0134 10.9003 10.9088 11.0696 10.8235 11.2486C10.7512 11.4004 10.6973 11.5616 10.5898 11.8843L10.2455 12.9173L10.1341 13.2515M17.4673 9.01732L13.9168 12.5678C13.6763 12.8083 13.556 12.9286 13.4234 13.032C13.267 13.1539 13.0978 13.2585 12.9188 13.3438C12.7669 13.4161 12.6057 13.47 12.283 13.5775L11.25 13.9218L10.9158 14.0332M10.1341 13.2515L10.0227 13.5857C9.96976 13.7445 10.0111 13.9196 10.1294 14.0379C10.2478 14.1562 10.4228 14.1976 10.5816 14.1446L10.9158 14.0332M10.1341 13.2515L10.9158 14.0332",
    stroke: "currentColor",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 10.834H8.75008",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 7.5H12.0834",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 14.166H7.91675",
    stroke: "currentColor",
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5237 2.64232C15.5474 1.66602 13.976 1.66602 10.8333 1.66602H9.16667C6.02397 1.66602 4.45262 1.66602 3.47631 2.64232C2.5 3.61864 2.5 5.18998 2.5 8.33268V11.666C2.5 14.8087 2.5 16.3801 3.47631 17.3563C4.45262 18.3327 6.02397 18.3327 9.16667 18.3327H10.8333C13.976 18.3327 15.5474 18.3327 16.5237 17.3563C17.3096 16.5704 17.4628 15.399 17.4928 13.3327",
    stroke: "currentColor",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeAgent);
export default __webpack_public_path__ + "static/media/change-agent.4303168fff7c7fe6990342917915652d.svg";
export { ForwardRef as ReactComponent };